import consumer from "./consumer"

consumer.subscriptions.create({ channel: "ReloadChannel" }, {
  connected() {
  },

  disconnected() {
  },

  received(data) {
    window.location.reload();
  }
});